import { useCallback } from 'react';
// import { useNavigation } from '@react-navigation/native';

export const useMoveToCategoryTab = () => {
  // const navigation = useNavigation();

  return useCallback(() => {
    // navigation.navigate('Category');
  }, []);
};
